import { defineStore } from 'pinia';
import { FundraisingDetail } from '@/models/fundraising-detail.model';

export const DEFAULT_PAGE_SIZE = 15;

export enum Sort {
  Relevance = '',
  AZ = 'a-z',
  ZA = 'z-a',
  New = 'newest-added',
}

interface FundraisingSearchStore {
  loaded: boolean;
  loading: boolean;
  keyword: string;
  sort?: Sort;
  page: number;
  pagesize: number;
  results: FundraisingDetail[];
  resultsCount: number;
}

export const useFundraisingSearchStore = defineStore('search', {
  state: (): FundraisingSearchStore => {
    return {
      loaded: false,
      loading: false,
      keyword: '',
      sort: undefined,
      page: 1,
      pagesize: DEFAULT_PAGE_SIZE,
      results: [] as FundraisingDetail[],
      resultsCount: 0,
    } as FundraisingSearchStore;
  },
  getters: {
    getLoading: (state) => state.loading,
    getLoaded: (state) => state.loaded,
    getKeyword: (state) => state.keyword,
    getSort: (state) => state.sort,
    getPage: (state) => state.page,
    getPagesize: (state) => state.pagesize,
    getResults: (state) => state.results,
    getResultsCount: (state) => state.resultsCount,
  },
});
